<template>
    <div>
        <el-form class="form" ref="form" label-width="100px">
            <el-checkbox class="checkbox" v-model="checked"></el-checkbox>
            <el-form-item label="四级高亮词" style="margin-bottom:12px;">
                <el-input v-model="data" type="textarea" :autosize="{minRows:1}" resize="none" placeholder="^分隔"></el-input>
            </el-form-item>
            <el-form-item label="显示背景色" style="margin-top: 10px;">
                <el-checkbox class="checkbox" v-model="showBg"></el-checkbox>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    props: { value: Object },
    name: 'LightThree',
    watch: {
        checked(newVal, oldVal) {
            this.submit();
        },
        data(newVal, oldVal) {
            this.submit();
        },
        showBg(newVal, oldVal) {
            this.submit()
        },
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            type: 'LightThree',
            checked: false,
            default: null,
            data: null,
            color: '#FEAC2B',
            background: '#FEF5E6',
            showBg: false,
        }
    },
    methods: {
        init() {
            this.checked = this.value.checked;
            this.data = this.value.value ? this.value.value : this.default;
            this.showBg = this.value.showBg ? this.value.showBg : this.showBg
        },
        submit() {
            var data = {
                type: this.type,
                checked: this.checked,
                value: this.data,
                color: this.color,
                background: this.background,
                showBg: this.showBg,
            }
            this.$emit('input', data)
        },
    }
}
</script>
<style lang="scss">
.form {
    display: flex;
    align-items: center;
}
</style>